<template>
    <div class="leave-detail-wrap">
        <div class="leave-detail-hd flex flex-align-center">
            <div class="stu-img"><img :src="leave.headUrl"></div>
            <div class="stu-info flex-1">
                <h3 class="stu-name">{{leave.name}}<span></span></h3>
                <span class="stu-class">({{leave.className}})</span>
            </div>
            <div class="status" v-if="leave.auditStatus == 0">未处理</div>
            <div class="status yes" v-if="leave.auditStatus == 1">已通过</div>
            <div class="status no" v-if="leave.auditStatus == -1">已拒绝</div>
        </div>
        <div class="leave-detail-con">
            <div class="detail-line flex">
                <div class="detail-title">请假人</div>
                <div class="detail-textarea flex-1">{{leave.name}}</div>
            </div>
            <div class="detail-line flex">
                <div class="detail-title">所在班级</div>
                <div class="detail-textarea flex-1">{{leave.className}}</div>
            </div>
            <div class="detail-line flex">
                <div class="detail-title">开始时间</div>
                <div class="detail-textarea flex-1">{{leave.startTime}}</div>
            </div>
            <div class="detail-line flex">
                <div class="detail-title">结束时间</div>
                <div class="detail-textarea flex-1">{{leave.endTime}}</div>
            </div>
            <div class="detail-line flex">
                <div class="detail-title">请假类型</div>
                <div class="detail-textarea flex-1">{{leave.leaveTypeName}}</div>
            </div>
            <div class="detail-line flex">
                <div class="detail-title">请假理由</div>
                <div class="detail-textarea flex-1">{{leave.leaveReason}}</div>
            </div>
            <div class="detail-line">
                <div class="detail-title">附件</div>
                <div class="appendix-flie">
                    <a :href="leave.attachmentCodeUrl" :download="file.name" class="flex" v-if="leave.attachmentCodeUrl != ''">
                        <div class="iconfont icon-wenjianjia"></div>
                        <div class="flie flex-1">{{file.name}}</div>
                        <span class="size">{{file.size}}</span>
                    </a>
                    <div class="flex" v-if="leave.attachmentCodeUrl == ''">
                        <div class="iconfont icon-wenjianjia"></div>
                        <div class="flie flex-1">无附件</div>
                        <span class="size">0.0KB</span>
                    </div>
                </div>
            </div>
            <div class="detail-line flex" v-if="leave.auditStatus != 0">
                <div class="detail-title">审核人</div>
                <div class="detail-textarea flex-1">{{leave.actualName}}</div>
            </div>

            <div class="leave-detail-ft flex" v-if="leave.auditStatus == 0 && type == 'teacher'">
                <button type="button" class="flex-1 handle-btn no" @click="audit(-1)">拒绝</button>
                <button type="button" class="flex-1 handle-btn yes" @click="audit(1)">批准</button>
            </div>
        </div>
        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>

<script>
import { Toast } from 'mint-ui';
import default_avatar from '@/assets/images/user.png?20241114'
import Bottom from '../bottom.vue'
export default {
    data() {
        return {
            leave: {},
            file: {},
            type: this.$route.query.type
        }
    },
    components: { Bottom },
    mounted () {
        this.$nextTick( () => {
            this.$http.get('/api/mobile/leave/queryLeaveById',{ params: {
                leaveId: this.$route.query.leaveId
            } })
            .then( res => {
                if(res.data.success) {
                    this.leave = res.data.leave;
                    this.file = res.data.flie;
                    this.leave.headUrl = this.leave.headUrl || default_avatar;
                } else {
                    alert(res.data.message);
                }
            })
        })
    },
    methods: {
        audit(auditstatus) {
            this.$http.get('/api/mobile/leave/auditStatus',{ params: {
                leaveId: this.$route.query.leaveId,
                auditStatus : auditstatus
            } })
            .then( res => {
                if(res.data.success) {
                    Toast('审核成功');
                    this.$router.replace({ name: 'Leave-teacher', query: {type: this.type}});
                } else {
                    alert(res.data.message);
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/attendance/leave-detail.vue